import { Col, Dropdown, Row } from 'antd'
import React from 'react'
import { curricullumcardProps } from './curriculumcard-interface'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../store/store'
import type { MenuProps } from 'antd';
import { useNavigate } from 'react-router-dom'

const Curriculumcard = ({ item }: curricullumcardProps) => {
	const navigate = useNavigate()

	const state = useSelector((state: RootState) => ({
		user: state.user.user,
	}))

	const { user } = state

	const items: MenuProps['items'] = [
		{
			key: `${item?._id}-open`,
			label: (
				<a rel="noopener noreferrer" href={`/teacher/dashboard/curriculum/${item._id}`}
					onClick={(e) => {
						e.preventDefault()
						navigate(`/teacher/dashboard/curriculum/${item._id}`)
					}}
				>
					Open
				</a>
			),
		},
	];

	return (
		<div className='mb-[1.8rem] p-[0.9rem] rounded-xl bg-appcolorwhitefainteight'>
			<p className='text-base font-[900] text-appcolorpurplefaintone capitalize'>{item?.name}</p>

			<div className='pt-4 mt-4 border-t-[0.3px] border-appcolorpurplefaintone flex'>
				<div className='flex-grow'>
					<Row gutter={8}>
						<Col xs={24} md={24} lg={12}>
							<div className='flex items-center mb-2'>
								<img src="/img/vectors/purpletime.svg" alt="users" className='w-5 h-5 mr-1' />

								<div className='flex items-center'>
									<p className='pr-1 text-sm font-extrabold text-appcolorpurplefaintone'>{item?.duration}</p>
									<p className='text-xs text-appcolorpurplefaintone'>{item?.durationUnit}{item?.duration > 1 ? 's' : ''}</p>
								</div>
							</div>
						</Col>
						{/* <Col xs={24} md={24} lg={12}>
							<div className='flex items-center mb-2'>
								<img src="/img/vectors/purpleminmod.svg" alt="users" className='w-5 h-5 mr-1' />

								<div className='flex items-center'>
									<p className='pr-1 text-sm font-extrabold text-appcolorpurplefaintone'>2</p>
									<p className='text-xs text-appcolorpurplefaintone'>min/module</p>
								</div>
							</div>
						</Col> */}
						<Col xs={24} md={24} lg={12}>
							<div className='flex items-center mb-2'>
								<img src="/img/vectors/purpledocument.svg" alt="users" className='w-5 h-5 mr-1' />

								<div className='flex items-center'>
									<p className='pr-1 text-sm font-extrabold text-appcolorpurplefaintone'>0</p>
									<p className='text-xs text-appcolorpurplefaintone'>assignments</p>
								</div>
							</div>
						</Col>
						<Col xs={24} md={24} lg={12}>
							<div className='flex items-center'>
								<img src="/img/vectors/purpleplans.svg" alt="users" className='w-5 h-5 mr-1' />
								<div className='flex items-center'>
									<p className='pr-1 text-sm font-extrabold text-appcolorpurplefaintone'>{item?.lessonPlans.length}</p>
									<p className='text-xs text-appcolorpurplefaintone'>lesson plan{item?.lessonPlans.length > 1 ? 's' : ''}</p>
								</div>
							</div>
						</Col>
					</Row>

					<div className='flex items-center mt-[1.4rem]'>
						<div className='custom-piped custom-piped-curicard pr-[0.6rem]'>
							{
								user?._id === item?.createdBy ?
									<>
										<img src={`${user?.userAvatarURL === undefined ?
											'/img/vectors/usertag.svg'
											:
											user?.userAvatarURL === '' ?
												'/img/vectors/usertag.svg' :
												user?.userAvatarURL
											}`}
											alt="usertag"
											className='w-6 h-6 rounded-full'
										/>
									</>
									:
									<>
										<img src="/img/logo/cfhcircle.svg" alt="cfhcircle" className='w-6 h-6 border rounded-full border-appcolororangethree' />
									</>
							}
						</div>

						<div className='ml-[0.6rem] flex items-center justify-between flex-grow'>
							<div className='flex flex-col'>
								<p className='text-xs text-appcolorpurplefaintone'>Created by</p>
								<p className='text-base font-extrabold text-appcolorpurplefaintone'>
									{
										user?._id === item?.createdBy ? `${user.userName}` : 'CFH'
									}
								</p>
							</div>

							{/* <div className='flex flex-col items-end'>
								<p className='text-xs text-appcolorpurplefaintone'>Assigned to</p>
								<div className='flex items-center'>
									<img src="/img/vectors/curicullumusers.svg" alt="users" className='w-6 h-6' />
									<p className='pr-1 text-base font-extrabold text-appcolorpurplefaintone'>2</p>
									<p className='text-sm text-appcolorpurplefaintone'>Classes</p>
								</div>
							</div> */}
						</div>
					</div>
				</div>
				<div className='flex items-end ml-4 w-fit'>
					<Dropdown
						menu={{ items }}
						placement="bottomRight"
					>
						<img src="/img/vectors/more.svg" alt="more" className='w-8 h-5 cursor-pointer' />
					</Dropdown>
				</div>
			</div>
		</div>
	)
}

export default Curriculumcard